export default __webpack_public_path__ + "static/media/transparency-step-2.08adc8c8.svg";